/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import {
	CosmosEntityFragment,
	PageHeroesFragment,
	RefSectionsEntitiesFragment,
	RefSectionsFragment,
} from "@cosmos/hygraph-schema";

import { getHeroDetails } from "./cosmosHeroQuery";
import { getRefSectionDetails, getRefSectionEntities } from "./cosmosSectionQuery";

export type GetHeroAndSectionsDetailsOptions = {
	locale: string;
	slug: string;
	lang: string;
	preview?: string;
};

export type GetHeroAndSectionsDetailsResponse = {
	hero: PageHeroesFragment | null;
	refSections: RefSectionsFragment[];
};

export const getHeroAndSectionsDetails = async (
	heroEntity: CosmosEntityFragment | undefined | null,
	refSectionsEntities: RefSectionsEntitiesFragment[] | undefined,
	{ locale, lang, preview }: GetHeroAndSectionsDetailsOptions,
): Promise<GetHeroAndSectionsDetailsResponse> => {
	const heroPromise: Promise<PageHeroesFragment | null> = getHeroDetails(heroEntity, locale, preview);
	const sectionsPromises = getRefSectionEntities(refSectionsEntities, locale, lang, preview) || [];

	const [hero, sectionsResponses] = await Promise.all([heroPromise, Promise.all(sectionsPromises)]);

	const refSections: RefSectionsFragment[] = getRefSectionDetails(sectionsResponses);

	if (hero) {
		return { hero, refSections };
	}

	return { hero: null, refSections };
};
